import { useGetHalIncotermsList } from '@views/screens/common/hooks/use-get-hal-incoterms-list.tsx';
import i18n from 'i18next';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';

export const HalIncotermSelect = ({
  placeholder = i18n.t('translation:default.fields.appointmentType.placeholder'),
  label = i18n.t('translation:default.fields.appointmentType.label'),
  rules = [],
  name,
  editMode,
  margin,
  tooltip = false,
  isDefault = false,
  onChange,
  dataTestId,
  isRequired = false,
}) => {
  const { data: options = [], isLoading } = useGetHalIncotermsList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={isDefault === true ? [{ label: 'Select', value: '' }, ...options] : options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      isRequired={isRequired}
      rules={rules}
      name={name}
      editMode={editMode}
      tooltip={tooltip}
      onChange={onChange}
      dataTestId={dataTestId}
    />
  );
};
